import * as colorfulSocialMediaIconMap from './colorfulSocialMediaIcon';
import * as whiteSocialMediaIconMap from './whiteSocialMediaIcon';

export { colorfulSocialMediaIconMap, whiteSocialMediaIconMap };
